export default __webpack_public_path__ + "static/media/half_filled.d64ff6f3.png";